export default "__VITE_ASSET__BUPYY1kU__"